import React, { useEffect } from "react";
import { Page, SubmitButton, FormGroup, DatePicker } from "components/common";
import { Control, actions, Errors } from "react-redux-form";
import { NotificationManager } from "react-notifications";
import { useForm } from "hooks";
import BackButton from "components/refactoring/BackButton";
import { Trans } from "react-i18next";

export const Edit = ({ t, model = "local", history, match, client }) => {
  const { id } = match.params;
  const { dispatch, setValue, Form, save, loaded } = useForm({
    model,
  });

  useEffect(() => {
    setValue({
      iqama_number: "",
      expiry_date: "",
      employee_notes: "",
      status: "PENDING",
    });
  }, []);

  const validateIqamaNumber = (value) => {
    // Iqama number validation - typically 10 digits
    return /^\d{10}$/.test(value);
  };

  async function onSubmit(item) {
    try {
      await save(client, `employees/${id}/iqama-renewal-requests`, item);
      NotificationManager.success(t("Iqama renewal request has been sent"));
      history.push('/employee_payroll');
    } catch (error) {
      NotificationManager.error(t(error.response?.data?.message || "An error occurred"));
    } finally {
      dispatch(actions.setPending(model, false));
    }
  }

  if (!loaded) return null;

  return (
    <Page title={t("Request Iqama Renewal")}>
      <BackButton />
      <Form
        onSubmit={onSubmit}
        // validators={{
        //   expiry_date: { required: true },
        //   employee_notes: { required: true },
        // }}
      >
        <div className="row">
          <div className="col-md-6">
            <FormGroup 
              label={t("Iqama Expiry Date *")} 
              model=".expiry_date" 
              className="my-2"
            >
              <DatePicker
                className="form-control"
                model=".expiry_date"
              />
            </FormGroup>
          </div>
        </div>
        
        <div className="row mt-3">
          <div className="col-md-6">
            <FormGroup 
              label={t("Notes *")} 
              model=".employee_notes" 
              className="my-2"
            >
              <Control.textarea 
                className="form-control" 
                model=".employee_notes"
                rows="3"
                placeholder={t("Add any additional notes or comments")}
              />
            </FormGroup>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="d-flex justify-content-end mt-4">
              <SubmitButton>
                <Trans>Submit Request</Trans>
              </SubmitButton>
            </div>
          </div>
        </div>
      </Form>
    </Page>
  );
};

export default Edit;
